// src/components/viewer/ViewerStats.jsx

import React from 'react';

const ViewerStats = ({ data }) => {
    return (
        <div className="viewer-stats-grid">
            <div className="viewer-stat-card">
                <div className="number">{data.totalUsers || 0}</div>
                <div className="label">Total Users</div>
            </div>
            <div className="viewer-stat-card success">
                <div className="number">{data.totalEligible || 0}</div>
                <div className="label">Eligible</div>
            </div>
            <div className="viewer-stat-card error">
                <div className="number">{data.totalIneligible || 0}</div>
                <div className="label">Not Eligible</div>
            </div>
            <div className="viewer-stat-card warning">
                <div className="number">{data.totalNotFound || 0}</div>
                <div className="label">Not Found</div>
            </div>
        </div>
    );
};

export default ViewerStats;